/*
  Sticky add-to-cart bar. The button submits the main product form (form attribute), so the cart
  flow is the regular product-form one. This script handles visibility, keeps price / sold-out state
  in sync after a variant change, and reserves room under the footer for the fixed bar.
*/
(function () {
  const SCROLL_THRESHOLD = 200;

  function updateVisibility(bar) {
    bar.classList.toggle('sticky-atc--active', window.scrollY > SCROLL_THRESHOLD);
  }

  function syncVariant(bar, event) {
    const { sectionId, html } = event.data;
    if (sectionId !== bar.dataset.section) return;

    const price = bar.querySelector('.sticky-atc__price');
    const priceSource = price && html.getElementById(price.id);
    if (priceSource) price.innerHTML = priceSource.innerHTML;

  }

  // The bar's button mirrors the main add-to-cart button (sold out / unavailable / disabled until a
  // personalisation is complete), so it can never add a variant the main form wouldn't.
  function mirrorMainButton(bar) {
    const button = bar.querySelector('button[name="add"]');
    const main = document.getElementById(`ProductSubmitButton-${bar.dataset.section}`);
    if (!button || !main) return;
    const sync = () => {
      button.toggleAttribute('disabled', main.hasAttribute('disabled'));
      const label = main.querySelector('span');
      if (label && main.hasAttribute('disabled')) button.querySelector('span').textContent = label.textContent;
      else if (bar.dataset.label) button.querySelector('span').textContent = bar.dataset.label;
    };
    new MutationObserver(sync).observe(main, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });
  }

  function init() {
    const bar = document.querySelector('.sticky-atc');
    if (!bar || bar.dataset.stickyReady) return;
    bar.dataset.stickyReady = 'true';

    if (bar.classList.contains('sticky-atc--after-scroll')) {
      const onScroll = () => updateVisibility(bar);
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    } else {
      bar.classList.add('sticky-atc--active');
    }

    mirrorMainButton(bar);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => syncVariant(bar, event));
    }

    const footer = document.querySelector('.footer');
    if (footer) footer.style.marginBottom = `${bar.offsetHeight - 1}px`;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
